import { parsePercent } from '../../../insight/helper';

const echartsModule = ThsDataVStandardChart?.echarts;

// 处理标签文本的z-index
function handleLabelZIndex(textEl, option) {
  if (typeof option?.label?.dvZ !== 'undefined') {
    textEl?.attr?.({ z: option.label.dvZ });
  }
  if (typeof option?.label?.dvZ2 !== 'undefined') {
    textEl?.attr?.({ z2: option.label.dvZ2 });
  }
}

// 处理线条样式
function handleLineStyle(el, symbolName: string, option) {
  if (typeof option?.lineStyle?.color !== 'undefined') {
    el.childOfName(symbolName)?.attr?.({ style: { fill: option.lineStyle.color } });
  }
}

// 处理网格内坐标
function handleGridCoordinate(el, option, index: number, hostSeries, markLineModel) {
  if (typeof option?.dvGridX !== 'undefined' || typeof option?.dvGridY !== 'undefined') {
    const gridRect = hostSeries.coordinateSystem.master.getRect();
    const lineEl = el.childOfName('line');
    let shape = {};

    if (typeof option?.dvGridX !== 'undefined') {
      shape = {
        [`x${index + 1}`]: gridRect.x + parsePercent(option.dvGridX, gridRect.width)
      };
    } else {
      shape = {
        [`y${index + 1}`]: gridRect.y + parsePercent(option.dvGridY, gridRect.height)
      };
    }

    // 重新启动动画
    lineEl.stopAnimation();
    lineEl.attr({
      shape: {
        ...shape,
        percent: 0
      }
    });
    echartsModule.graphic.updateProps(
      lineEl,
      {
        shape: {
          percent: 1
        }
      },
      markLineModel,
      index
    );
  }
}

// 处理标签文本
function handleLabelText(el, option) {
  if (typeof option?.dvLabelText !== 'undefined') {
    const textEl = el.getTextContent();
    textEl?.attr?.({
      style: { text: option.dvLabelText },
      states: {
        blur: { style: { text: option.dvLabelText } },
        emphasis: { style: { text: option.dvLabelText } },
        select: { style: { text: option.dvLabelText } }
      }
    });
  }
}

// 处理符号隐藏
function handleSymbolNone(el, option) {
  if (option?.dvSymbolNone === true) {
    ['fromSymbol', 'toSymbol'].forEach(symbolName => {
      el.childOfName(symbolName)?.hide?.();
    });
  }
}

function postProcessMarkLine(markLine, ecModal, api) {
  const view = api.getViewOfComponentModel(markLine);

  // ! 依赖于源码实现
  view?.markerGroupMap?.each?.(lineDraw => {
    const lineData = lineDraw?._lineData;
    const markLineModel = lineData?.hostModel;
    const hostSeries = markLineModel?.__hostSeries;

    lineData?.each?.((idx: number) => {
      const option = markLineModel?.option?.data?.[idx];
      const el = lineData.getItemGraphicEl(idx);

      if (Array.isArray(option)) {
        ['fromSymbol', 'toSymbol'].forEach((symbolName, index) => {
          // * 允许对标签文本设置层级
          handleLabelZIndex(el.getTextContent(), option[index]);

          // * 允许首尾设置不一样的颜色
          handleLineStyle(el, symbolName, option[index]);

          // * 指定在 grid 内的坐标
          handleGridCoordinate(el, option[index], index, hostSeries, markLineModel);
        });

        return;
      }

      // * 利用额外的配置项处理标签文本 name 被 value 覆盖的情况
      handleLabelText(el, option);

      // * 处理 symbol 设置为 'none' 不生效的问题
      handleSymbolNone(el, option);
    });
  });
}

export function install(registers) {
  registers.registerUpdateLifecycle('series:afterupdate', (ecModal, api) => {
    const markLines = ecModal.findComponents({ mainType: 'markLine' }) as unknown[];

    markLines.forEach(markLine => {
      postProcessMarkLine(markLine, ecModal, api);
    });
  });
}
